import React from "react";
import "./Ceodb.scss";
import { FaEllipsisV, FaSearch, FaCommentDots } from "react-icons/fa";

const comments = [
    {
        id: 1,
        rating: "neutral",
        text: "I feel completely comfortable being myself at work.",
        date: "04-Nov-2025 05:30"
    },
    {
        id: 2,
        rating: "neutral",
        text: "The organization genuinely cares about me as a person.",
        date: "04-Nov-2025 05:30"
    },
    {
        id: 3,
        rating: "neutral",
        text: "In a very good mood today.",
        date: "04-Nov-2025 05:30"
    }
];

const getEmoji = () => "😐";

const AllCommentsPreview = () => {
    return (
        <div className="all-comments-preview">
            {/* Header */}
            <div className="page-title">
                <FaCommentDots />
                <span>All Comments</span>
            </div>

            {/* Top Filters */}
            <div className="top-filters">
                <div className="total-comments">
                    Total Comments: <b>618</b>
                </div>

                <select>
                    <option>Please select Statement</option>
                </select>

                <div className="search-box">
                    <input placeholder="Search" />
                    <FaSearch />
                </div>

                {/* Sentiment bar */}
                <div className="sentiment-bar">
                    <div className="sentiment green">0</div>
                    <div className="sentiment yellow">100%</div>
                    <div className="sentiment red">0</div>
                </div>
            </div>

            {/* Table */}
            <div className="comments-table">
                <div className="table-header">
                    <span>Rating</span>
                    <span>Comment</span>
                    <span>Date</span>
                    <span>Action</span>
                </div>

                {comments.map((item) => (
                    <div className="table-row" key={item.id}>
                        <span className="rating">{getEmoji()}</span>
                        <span className="comment-text">{item.text}</span>
                        <span className="date">{item.date}</span>
                        <span className="action">
                            <FaEllipsisV />
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AllCommentsPreview;